export default __webpack_public_path__ + "static/media/quote_sent_desktop.3714ee6a.svg";